import React, { useEffect, useRef, useState } from "react";
import Layout from "../../components/layouts/Layout";
import BreadcrumbBlock from "../../components/BreadcrumbBlock/BreadcrumbBlock";
import { Link } from "react-router-dom";
import {
  Badge,
  Button,
  Flex,
  Input,
  notification,
  PaginationProps,
  Select,
  SelectProps,
  Table,
  TableColumnsType,
  Dropdown,
  Menu,
  Tooltip,
} from "antd";
import {
  ArrowSquareDown,
  Category2,
  DocumentDownload,
  ElementPlus,
  Flag,
  Home2,
  Profile2User,
  SearchZoomIn,
  DollarCircle,
  DocumentText,
} from "iconsax-react";
import {
  ArrowLeftOutlined,
  ArrowRightOutlined,
  MenuOutlined,
} from "@ant-design/icons";
import DeleteModal from "../../components/Modal/DeleteModal";
import CreateMyStorePopup from "./Popup/CreateMyStore";
import ViewMyStorePopup from "./Popup/ViewMyStore";
import UpdateMyStorePopup from "./Popup/UpdateMyStore";
import CreateOwnerStorePopup from "./Popup/CreateOwnerStore";
import ViewOwnerStorePopup from "./Popup/ViewOwnerStore";
import UpdateOwnerStorePopup from "./Popup/UpdateOwnerStore";
import { mixGetV1, mixPostV1 } from "../../services/mixin";
import * as XLSX from "xlsx";
import DevicesOfStoreModal from "./Popup/DevicesOfStoreModal";
import PaymentHistoryModal from "./Popup/PaymentHistoryModal";
import PaymentConfirmationModal from "./Popup/PaymentConfirmationModal";
import "./StoreList.scss";

type LabelRender = SelectProps["labelRender"];
const customSelectedLabel: LabelRender = (props) => {
  const { label, value } = props;

  if (value && label) {
    return (
      <Flex align="center" gap={8}>
        <Category2 size={18} variant="Bulk" style={{ flexShrink: 0 }} />
        <span>{label}</span>
      </Flex>
    );
  }
  return (
    <Flex align="center" gap={8}>
      <Category2 size={18} variant="Bulk" style={{ flexShrink: 0 }} />
      <span>Type</span>
    </Flex>
  );
};
const customSelectedLabel2: LabelRender = (props) => {
  const { label, value } = props;

  if (value && label) {
    return (
      <Flex align="center" gap={8}>
        <SearchZoomIn size={18} variant="Bulk" style={{ flexShrink: 0 }} />
        <span>{label}</span>
      </Flex>
    );
  }
  return (
    <Flex align="center" gap={8}>
      <SearchZoomIn size={18} variant="Bulk" style={{ flexShrink: 0 }} />
      <span>Select Owner</span>
    </Flex>
  );
};
const customSelectedLabel3: LabelRender = (props) => {
  const { label, value } = props;

  if (value && label) {
    return (
      <Flex align="center" gap={8}>
        <Flag size={18} variant="Bulk" style={{ flexShrink: 0 }} />
        <span>{label}</span>
      </Flex>
    );
  }
  return (
    <Flex align="center" gap={8}>
      <Flag size={18} variant="Bulk" style={{ flexShrink: 0 }} />
      <span>Status</span>
    </Flex>
  );
};

const customPrevNext: PaginationProps["itemRender"] = (
  _,
  type,
  originalElement,
) => {
  if (type === "prev") {
    return (
      <Flex align="center" gap={8}>
        <ArrowLeftOutlined />
        <span>Previous</span>
      </Flex>
    );
  }
  if (type === "next") {
    return (
      <Flex align="center" gap={8}>
        <span>Next</span>
        <ArrowRightOutlined />
      </Flex>
    );
  }
  return originalElement;
};

const StoreList: React.FC = () => {
  const [showDeleteStorePopup, setShowDeleteStorePopup] = useState(false);
  const [showStopStorePopup, setShowStopStorePopup] = useState(false);
  const [createMyStoreShow, setCreateMyStoreShow] = useState(false);
  const [viewMyStoreShow, setViewMyStoreShow] = useState(false);
  const [updateMyStoreShow, setUpdateMyStoreShow] = useState(false);
  const [createOwnerStoreShow, setCreateOwnerStoreShow] = useState(false);
  const [viewOwnerStoreShow, setViewOwnerStoreShow] = useState(false);
  const [updateOwnerStoreShow, setUpdateOwnerStoreShow] = useState(false);
  const [selectedId, setSelectedId] = useState<any>();
  const [showPaymentHistory, setShowPaymentHistory] = useState(false);
  const [showPaymentConfirm, setShowPaymentConfirm] = useState(false);
  // const [paymentHistoryLoading, setPaymentHistoryLoading] = useState(false);
  // const [paymentHistory, setPaymentHistory] = useState<any[]>([]);
  // const [paymentInfo, setPaymentInfo] = useState<any>(null);
  const [visibleTooltipId, setVisibleTooltipId] = useState<string | null>(null);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);
  const handleTooltipChange = (visible: boolean, recordId: string) => {
    if (visible) {
      setVisibleTooltipId(recordId);
      // auto-close tooltip sau 2s
      timeoutRef.current = setTimeout(() => {
        setVisibleTooltipId(null);
      }, 2000);
    } else {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      setVisibleTooltipId(null);
    }
  };
  // role_id: 1:admin, 2:owner, 3:sales, 4:user
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const roleId: any = user.role_id;

  const menu = (record: any) => (
    <Menu>
      <Menu.Item
        key="edit"
        onClick={() => {
          setSelectedId(record.store_id);
          record.store === "My store"
            ? setUpdateMyStoreShow(true)
            : setUpdateOwnerStoreShow(true);
        }}
      >
        Edit
      </Menu.Item>
      {record.is_expired === 0 && (
        <Menu.Item
          key="stop"
          onClick={() => {
            setSelectedId(record.store_id);
            setShowStopStorePopup(true);
          }}
        >
          Stop
        </Menu.Item>
      )}

      <Menu.Item
        key="delete"
        onClick={() => {
          setSelectedId(record.store_id);
          setShowDeleteStorePopup(true);
        }}
      >
        Delete
      </Menu.Item>
      <Menu.Item
        key="device"
        onClick={() => {
          setSelectedId(record.store_id);
          setShowStoreDevicesModal(true);
        }}
      >
        Device
      </Menu.Item>
    </Menu>
  );

  const columns: TableColumnsType = [
    {
      title: "No.",
      key: "stt",
      width: 70,
      align: "center",
      render: (_: any, __: any, index: number) =>
        (params.page_number - 1) * params.limit + index + 1,
    },
    {
      title: "",
      key: "actions",
      fixed: "left",
      className: "actions-sticky actions-sticky--left",
      render: (record: any) => (
        <Flex align="center" gap={4}>
          {roleId === 1 && (
            <>
              {record.is_expired !== 0 ? (
                <Tooltip
                  title="Renew"
                  placement="bottom"
                  open={visibleTooltipId === `${record.store_id}-limit`}
                  onOpenChange={(visible) =>
                    handleTooltipChange(visible, `${record.store_id}-limit`)
                  }
                >
                  <Button
                    icon={<DollarCircle size={25} variant="Bulk" />}
                    className="rs-button"
                    onClick={() => {
                      setSelectedId(record.store_id);
                      setShowPaymentConfirm(true);
                    }}
                  />
                </Tooltip>
              ) : (
                <span style={{ width: 40, display: "inline-block" }}></span>
              )}
            </>
          )}

          <Tooltip
            title="Transaction history"
            placement="bottom"
            open={visibleTooltipId === `${record.store_id}-history`}
            onOpenChange={(visible) =>
              handleTooltipChange(visible, `${record.store_id}-history`)
            }
          >
            <Button
              icon={<DocumentText size={25} variant="Bulk" />}
              className="rs-button"
              onClick={() => {
                setSelectedId(record.store_id);
                setShowPaymentHistory(true);
              }}
            />
          </Tooltip>
          <Dropdown
            overlay={menu(record)}
            trigger={["click"]}
            placement="bottomLeft"
          >
            <Button icon={<MenuOutlined />} />
          </Dropdown>
        </Flex>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status, record) => {
        let className = "status-active";
        let text = record.status_name;
        if (record.is_expired === 2) {
          className = "status-warning";
          text = "Due soon";
        } else if (record.is_expired === 3) {
          className = "status-unpaid";
          text = "Unpaid";
        } else if (record.is_expired === 0) {
          className = "status-active";
          text = "Active";
        }
        return (
          <span className={`title-15 font-medium value ${className}`}>
            {text}
          </span>
        );
      },
    },
    {
      title: "Type",
      dataIndex: "type_id",
      key: "type_id",
      render: (type_id, record) => (
        // <Badge status={storeType(type_id).color} text={ record.type_name } className='rs-badge background' />
        <Badge
          status={type_id === 1 ? "warning" : "default"}
          text={record.type_name}
          className="rs-badge background"
        />
      ),
    },
    {
      title: "Last active",
      dataIndex: "last_active",
      key: "last_active",
      render: (last_active, record) => (
        <span
          className={`title-15 font-medium value ${
            last_active === 0
              ? "status-active"
              : last_active <= 7
                ? "status-warning"
                : "status-unpaid"
          }`}
        >
          {`${last_active > 0 ? last_active : ""} ${
            last_active === 0 ? "active now" : "day ago"
          }`}
        </span>
      ),
    },
    {
      title: "Store ID",
      dataIndex: "store_id",
      key: "store_id",
    },
    {
      title: "Store",
      dataIndex: "store",
      key: "store",
    },
    {
      title: "Store name",
      dataIndex: "store_name",
      key: "store_name",
    },
    {
      title: "Owner name",
      dataIndex: "owner_name",
      key: "owner_name",
      // render: (text, record) => (
      //   <Flex align='center' gap={8}>
      //     <Avatar size={40} src={record.ownerAvatar} />
      //     <span>{ text }</span>
      //   </Flex>
      // )
    },
    {
      title: "Owner Phone",
      dataIndex: "phone_number",
      key: "phone_number",
    },
    {
      title: "Owner email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Created at",
      dataIndex: "create_at",
      key: "create_at",
    },
    {
      title: "Date expired",
      dataIndex: "date_expired",
      key: "date_expired",
    },
    {
      title: "Seller name",
      dataIndex: "seller_name",
      key: "seller_name",
      render: (text, record) => (
        <Flex align="center" gap={8}>
          {/* <Avatar size={40} src={record.sellerAvatar} /> */}
          <Flex vertical>
            <span>{text}</span>
            <span className="title-12 neutral-gray-500">
              Seller ID {record.seller_id}
            </span>
          </Flex>
        </Flex>
      ),
    },
    // {
    //   title: 'Sent SMS',
    //   dataIndex: 'sentSMS',
    //   key: 'sentSMS',
    // },
    {
      title: "Address",
      dataIndex: "address",
      key: "address",
    },
  ];

  useEffect(() => {
    getItems();
    getOwners();
    getStoreTypes();
    getStatusStore();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // GET OWNERS
  const [owners, setOwners] = useState([] as any);
  const getOwners = async () => {
    try {
      const res = await mixPostV1("/api/webAdmin/gComboOwner.php", {});

      if (res.status === 1) {
        const result: any = [];
        res.data.map((item: any) =>
          result.push({
            ...item,
            value: item.id,
            label: item.owner_name,
          }),
        );
        setOwners(result);
      }
    } catch (error) {}
  };
  // END GET OWNERS

  // GET SERVICE TYPES
  const [serviceTypes, setServiceTypes] = useState([] as any);
  const getStoreTypes = async () => {
    try {
      const res = await mixGetV1("/api/webAdmin/gComboTypeStore.php");

      if (res.status === 1) {
        const result: any = [];
        res.data.map((item: any) =>
          result.push({
            ...item,
            value: item.type_id,
            label: item.type_name,
          }),
        );
        setServiceTypes(result);
      }
    } catch (error) {}
  };
  // END GET SERVICE TYPES

  // GET STATUS STORE
  const [statusStore, setStatusStore] = useState([] as any);
  const getStatusStore = async () => {
    try {
      const res = await mixGetV1("/api/webAdmin/gComboStatusStore.php", {});

      if (res.status === 1) {
        const result: any = [];
        res.data.map((item: any) =>
          result.push({
            ...item,
            value: item.status,
            label: item.status_name,
          }),
        );
        setStatusStore(result);
      }
    } catch (error) {}
  };
  // END GET STATUS STORE

  // GET LIST
  const [items, setItems] = useState({
    list: [],
    total: 0,
  });
  const [tableLoading, setTableLoading] = useState(false);

  const [params, setParams] = useState<{
    limit: number;
    page_number: number;
    searchOwnerId?: number | string;
    searchStatus?: number | string;
    searchType?: number | string;
    searchStoreName?: string;
  }>({
    limit: 10,
    page_number: 1,
    searchOwnerId: "",
    searchStatus: "",
    searchType: "",
    searchStoreName: "",
  });

  const [searchStoreNameInput, setSearchStoreNameInput] = useState("");
  const [searchTimeout, setSearchTimeout] = useState<any>(null);

  const handleSearchStoreNameChange = (val: string) => {
    setSearchStoreNameInput(val);
    if (searchTimeout) {
      clearTimeout(searchTimeout);
    }
    const timeout = setTimeout(() => {
      setParams((prevParams) => ({
        ...prevParams,
        searchStoreName: val,
        page_number: 1,
      }));
    }, 400);
    setSearchTimeout(timeout);
  };

  const getItems = async () => {
    setTableLoading(true);
    try {
      let res;

      if (roleId === 3) {
        res = await mixPostV1("/api/webAdmin/gListStoreSeller.php", params);
      } else {
        res = await mixPostV1("/api/webAdmin/gListStoreOwner.php", params);
      }

      if (res && res.status === 1) {
        setItems({
          list: res.data || [],
          total: res.total || 0,
        });
      }
    } catch (error) {
      console.error(error);
    } finally {
      setTableLoading(false);
    }
  };

  useEffect(() => {
    getItems();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);

  const onPageChange = (page: number) => {
    setParams({
      ...params,
      page_number: page,
    });
  };

  const onTableChange = (data: any) => {
    setParams({
      ...params,
      page_number: data.current,
      limit: data.pageSize,
    });
  };
  // END GET LIST

  // EXPORT EXCEL
  const getItemsByExcel = async () => {
    const customParams = {
      ...params,
      page_number: 1,
      limit: 10000,
    };

    try {
      setTableLoading(true);
      const res = await mixPostV1(
        "/api/webAdmin/gListStoreOwner.php",
        customParams,
      );

      if (res.status) {
        if (res.data.length > 0) {
          formattedDataExcel(res.data);
          setTableLoading(false);
        } else {
          openNotification("error", "There is no data to export!");
          setTableLoading(false);
        }
      } else {
        openNotification("error", "Oops, something went wrong!");
        setTableLoading(false);
      }
    } catch (error) {
      openNotification("error", "Oops, something went wrong!");
      setTableLoading(false);
    } finally {
      setTableLoading(false);
    }
  };
  const formattedDataExcel = (data: any) => {
    const formattedData = data.map((item: any) => {
      return {
        Status: item.status_name,
        Type: item.type_name,
        "Store ID": item.store_id,
        Store: item.store,
        "Store name": item.store_name,
        "Owner name": item.owner_name,
        "Owner phone": item.phone_number,
        "Owner email": item.email,
        "Create at": item.create_at,
        "Seller name": item.seller_name,
        // 'Sent SMS': item.sent_sms || '',
        Address: item.address,
      };
    });
    exportExcel(formattedData);
  };
  const exportExcel = (convertData: any): boolean => {
    try {
      const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(convertData);
      const workbook: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Danh sách");

      const excelBuffer: ArrayBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "buffer",
      });

      const saveAsExcel = (buffer: ArrayBuffer, fileName: string): void => {
        const data: Blob = new Blob([buffer], {
          type: "application/octet-stream",
        });
        const link: HTMLAnchorElement = document.createElement("a");
        link.href = window.URL.createObjectURL(data);
        link.download = fileName;
        link.click();
      };

      saveAsExcel(excelBuffer, `${"Live Store"}.xlsx`);
      return true; // Export successful
    } catch (error) {
      console.error("Error exporting Excel:", error);
      return false; // Export failed
    }
  };
  // END EXPORT EXCEL

  // NOTIFICATION
  const [api, contextHolder] = notification.useNotification();
  const openNotification = (
    type: "success" | "info" | "warning" | "error" = "success",
    message = "Request success!",
  ) => {
    api[type]({
      message: message,
      placement: "bottomRight",
      className: "single-message",
    });
  };

  // STORE'S DEVICES MODAL
  const [showStoreDevicesModal, setShowStoreDevicesModal] = useState(false);

  // GET STORES
  const getStores = async () => {
    const res = await mixPostV1(
      "/api/webAdmin/gComboStoreByOwnerForAdmin.php",
      {
        owner_id: user.id,
      },
    );
    if (res.status === 1) {
      if (Number(user?.role_id) === 1) {
        const allStores = res.data.flatMap(
          (owner: any) => owner.listStore || [],
        );
        localStorage.setItem("stores", JSON.stringify(allStores));
      } else {
        const stores = res.data.map((item: any) => ({
          ...item,
          key: item?.store_id?.toString(),
          label: item.store_name,
        }));
        localStorage.setItem("stores", JSON.stringify(stores));
      }
    }
  };

  // useEffect(() => {
  //   if (showPaymentHistory && selectedId) {
  //     setPaymentHistoryLoading(true);
  //     setPaymentHistory([]);
  //     setPaymentInfo(null);
  //     mixPostV1("/api/webAdmin/gListHistorypaymentStore.php", {
  //       store_id: selectedId,
  //     })
  //       .then((res: any) => {
  //         if (res.status === 1 && res.data) {
  //           setPaymentHistory(res.data.historyPayment || []);
  //           setPaymentInfo(res.data.infoPlanStore || null);
  //         }
  //       })
  //       .finally(() => setPaymentHistoryLoading(false));
  //   }
  // }, [showPaymentHistory, selectedId]);

  const selectedStore =
    (items.list.find(
      (item: any) => String(item.store_id) === String(selectedId),
    ) as any) || {};
  const confirmStoreName = selectedStore?.store_name || "-";
  const confirmIncome = selectedStore?.income || "0";

  // // Hàm xử lý payment manual
  // const handleManualPayment = async () => {
  //   if (!selectedId) return;
  //   try {
  //     await mixPostV1("/api/webAdmin/manualPayment.php", {
  //       store_id: String(selectedId),
  //     });
  //     openNotification("success", "Payment success!");
  //     setShowPaymentConfirm(false);
  //   } catch (e) {
  //     openNotification("error", "Payment failed!");
  //   }
  // };

  return (
    <>
      {contextHolder}

      <Layout contentClassName="store-list-content">
        <BreadcrumbBlock
          items={[
            {
              title: (
                <Flex align="center" gap={16}>
                  <Home2 variant="Bulk" />
                  <Link to="/">CMD Tech</Link>
                </Flex>
              ),
            },
            { title: "Store List" },
            { title: "Live store" },
          ]}
          title="Live store"
          description=""
        />

        <div className="table-filter-block">
          <Input
            allowClear
            value={searchStoreNameInput}
            placeholder="Search store name"
            prefix={<SearchZoomIn size={20} variant="Bulk" style={{ flexShrink: 0 }} />}
            className="rs-input mw-288 mw-100-767"
            onChange={(e) => handleSearchStoreNameChange(e.target.value)}
          />

          <Select
            allowClear={params.searchOwnerId !== ""}
            value={params.searchOwnerId}
            options={owners}
            placeholder="Select Owner"
            popupMatchSelectWidth={false}
            suffixIcon={<ArrowSquareDown size={20} variant="Bulk" />}
            className="rs-select mw-288 mw-100-767 grid-area-search"
            popupClassName="rs-select-dropdown"
            labelRender={customSelectedLabel2}
            onChange={(value) =>
              setParams({
                ...params,
                searchOwnerId: value ? Number(value) : "",
                page_number: 1,
              })
            }
          />

          <Select
            allowClear={params.searchType !== ""}
            value={params.searchType}
            options={serviceTypes}
            placeholder="Type"
            popupMatchSelectWidth={false}
            suffixIcon={<ArrowSquareDown size={20} variant="Bulk" />}
            labelRender={customSelectedLabel}
            className="rs-select mw-173 mw-100-767 grid-area-type"
            popupClassName="rs-select-dropdown"
            onChange={(value) =>
              setParams({
                ...params,
                searchType: value ? Number(value) : "",
                page_number: 1,
              })
            }
          />

          <Select
            allowClear={params.searchStatus !== ""}
            value={params.searchStatus}
            options={statusStore}
            placeholder="Status"
            popupMatchSelectWidth={false}
            suffixIcon={<ArrowSquareDown size={20} variant="Bulk" />}
            labelRender={customSelectedLabel3}
            className="rs-select mw-173 mw-100-767 grid-area-status"
            popupClassName="rs-select-dropdown"
            onChange={(value) =>
              setParams({
                ...params,
                searchStatus: typeof value !== "undefined" ? Number(value) : "",
                page_number: 1,
              })
            }
          />

          <Button
            icon={<DocumentDownload size={20} variant="Bulk" />}
            className="rs-button mis-auto grid-area-export"
            onClick={getItemsByExcel}
          >
            Export
          </Button>

          {roleId !== 3 && (
            <Button
              icon={<ElementPlus size={20} variant="Bulk" />}
              className="rs-button grid-area-my-store"
              onClick={() => setCreateMyStoreShow(true)}
            >
              Create my store
            </Button>
          )}

          <Button
            icon={<Profile2User size={20} variant="Bulk" />}
            className="rs-button grid-area-owner-store"
            onClick={() => setCreateOwnerStoreShow(true)}
          >
            Create owner store
          </Button>
        </div>

        <Table
          columns={columns}
          dataSource={items.list}
          className="rs-table table-text-nowrap match-height"
          loading={tableLoading}
          rowKey="store_id"
          scroll={{
            x: true,
          }}
          pagination={{
            pageSize: params.limit,
            current: params.page_number,
            position: ["bottomCenter"],
            showSizeChanger: true,
            showTitle: false,
            total: items.total,
            itemRender: customPrevNext,
            onChange: (e) => onPageChange(e),
          }}
          onChange={onTableChange}
        />

        {/* DELETE STORE */}
        <DeleteModal
          isShow={showDeleteStorePopup}
          content="Are you sure you want to delete this Store?"
          message="Store deleted!"
          deleteApi="/api/webAdmin/deleteStoreOwner.php"
          deleteId={selectedId}
          deleteKey="store_id"
          onModalClose={() => setShowDeleteStorePopup(false)}
          onModalSubmit={() => {
            getItems();
            setShowDeleteStorePopup(false);
            getStores();
          }}
        />
        <DeleteModal
          isShow={showStopStorePopup}
          is_stop={1}
          content="Are you sure you want to stop this Store?"
          message="Stop Store!"
          deleteApi="/api/webAdmin/stopStatusStore.php"
          yesText="Yes, Stop"
          deleteId={selectedId}
          deleteKey="store_id"
          onModalClose={() => setShowStopStorePopup(false)}
          onModalSubmit={() => {
            getItems();
            setShowStopStorePopup(false);
            getStores();
          }}
        />
        {/* CREATE MY STORE */}
        <CreateMyStorePopup
          isShow={createMyStoreShow}
          onPopupClose={() => setCreateMyStoreShow(false)}
          onSuccess={() => {
            getItems();
            setCreateMyStoreShow(false);
            getStores();
          }}
        />

        {/* VIEW MY STORE */}
        <ViewMyStorePopup
          id={selectedId}
          isShow={viewMyStoreShow}
          onPopupClose={() => setViewMyStoreShow(false)}
          onOpenEdit={() => setUpdateMyStoreShow(true)}
          onSuccess={() => {
            getItems();
            setUpdateMyStoreShow(false);
            getStores();
          }}
        />

        {/* UPDATE MY STORE */}
        <UpdateMyStorePopup
          id={selectedId}
          isShow={updateMyStoreShow}
          onPopupClose={() => setUpdateMyStoreShow(false)}
          onSuccess={() => {
            getItems();
            setUpdateMyStoreShow(false);
            getStores();
          }}
        />

        {/* CREATE OWNER STORE */}
        <CreateOwnerStorePopup
          isShow={createOwnerStoreShow}
          onPopupClose={() => setCreateOwnerStoreShow(false)}
          onSuccess={() => {
            getItems();
            setCreateOwnerStoreShow(false);
            getStores();
          }}
        />

        {/* VIEW OWNER STORE */}
        <ViewOwnerStorePopup
          id={selectedId}
          isShow={viewOwnerStoreShow}
          onPopupClose={() => setViewOwnerStoreShow(false)}
          onOpenEdit={() => setUpdateOwnerStoreShow(true)}
          onSuccess={() => {
            getItems();
            setUpdateMyStoreShow(false);
            getStores();
          }}
        />

        {/* UPDATE OWNER STORE */}
        <UpdateOwnerStorePopup
          id={selectedId}
          isShow={updateOwnerStoreShow}
          onPopupClose={() => setUpdateOwnerStoreShow(false)}
          onSuccess={() => {
            getItems();
            setUpdateOwnerStoreShow(false);
            getStores();
          }}
        />

        {/* STORE'S DEVICES MODAL */}
        <DevicesOfStoreModal
          storeId={selectedId}
          show={showStoreDevicesModal}
          onModalClose={() => setShowStoreDevicesModal(false)}
        />

        {/* PAYMENT HISTORY MODAL */}
        <PaymentHistoryModal
          isShow={showPaymentHistory}
          storeId={String(selectedId || "")}
          onClose={() => setShowPaymentHistory(false)}
        />

        {/* PAYMENT CONFIRMATION MODAL */}
        <PaymentConfirmationModal
          isShow={showPaymentConfirm}
          storeName={confirmStoreName}
          income={confirmIncome}
          storeId={selectedId}
          onClose={() => setShowPaymentConfirm(false)}
          onSuccess={() => {
            getItems();
            openNotification("success", "Payment success!");
          }}
        />
      </Layout>
    </>
  );
};

export default StoreList;
